// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//Vue.config.productionTip = false

import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
Vue.use(iView)
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import '../static/css/common.css'
import '../static/css/lcommon.less'
import moment from 'moment'
import {duration} from 'moment'
import store from './store'

import svgLoading from './components/new/common/svgLoading'
Vue.component(svgLoading.name, svgLoading)

import registeAPI from '@/api/registe.service.js';

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

export function formatDate (date, fmt){
  if(date){
    return moment(date).format(fmt);
  }else {
    return '';
  }
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length);
}

const filters = {
  formatDate
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})
Vue.directive('twinkle', {
  update(el,binding) {
    if (binding.value === binding.oldValue) {
      return;
    }
    //指令传入得触发动画得className
    let className = binding.arg;
    el.classList.remove(className);
    setTimeout(() => {
      el.classList.add(className);
    }, 100);
  }
})


// 增加未完成axios销毁处理
window.__axiosPromiseCancelArr = [];

function axiosPromiseCancelFun() {
  window.__axiosPromiseCancelArr.forEach((e, idx) => {
    if(e) {
      e();
      delete window.__axiosPromiseCancelArr[idx];
    }
  });
}

router.beforeEach((to,from,next) => {
  let _usePath = ['/evidenceRecord','/liarInfoQuestion'];
  if(_usePath.includes(from.path)) {
    axiosPromiseCancelFun();
  }
  next();
});
// 获取签名地址
async function presignedUrlFun(fileHost, filePath) {
  let _url = '';
  if(localStorage.openPresignedUrlType) {
    let res = await registeAPI.getPresignedUrl({
      "filePath": filePath
    });
    if(res.flag == '1') {
      _url = res.data;
    } else {
      _url = '';
    }
  }
  return fileHost + _url;
}
/**
 * 全局混入自定义事件
 * */
Vue.mixin({
  methods: {
    moment,
    momentDuration: duration,
    axiosPromiseCancelFun: axiosPromiseCancelFun,
    // 判断对象中是否有值
    isHasVal(dataItem, itemKeys) {
      let _hasFlag = false;
      if(itemKeys && itemKeys.length > 0) {
        for(let o in dataItem) {
          if(itemKeys.includes(o) && dataItem[o]) {
            _hasFlag = true;
            break;
          }
        }
      } else {
        for(let o in dataItem) {
          if(dataItem[o]) {
            _hasFlag = true;
            break;
          }
        }
      }
      return _hasFlag;
    },
    //查看大图
    viewImgLarge(srcxx) {
      this.$store.commit('viewImgChange', srcxx);
    },
    // 生成随机id
    getUuid(){
      var originStr = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
        originChar = '0123456789abcdef',
        len = originChar.length;
      return originStr.replace(/x/g, function(match) {
        return originChar.charAt(Math.floor(Math.random() * len))
      }).replace(/-/g, "")
    },
    mathAdd(a, b) {
      let vm = this;
      var c, d, e;
      try {
        c = a.toString().split(".")[1].length;
      } catch (f) {
        c = 0;
      }
      try {
        d = b.toString().split(".")[1].length;
      } catch (f) {
        d = 0;
      }
      return e = Math.pow(10, Math.max(c, d)), (vm.mathMul(a, e) + vm.mathMul(b, e)) / e;
    },
    mathMul(a, b) {
      var c = 0,
        d = a.toString(),
        e = b.toString();
      try {
        c += d.split(".")[1].length;
      } catch (f) {}
      try {
        c += e.split(".")[1].length;
      } catch (f) {}
      return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
    },
    formatFileSize(value) {
      if(null==value||value==''){
        return "0B";
      }
      var unitArr = new Array("B","KB","MB","GB","TB","PB","EB","ZB","YB");
      var srcsize = parseFloat(value);
      var index = Math.floor(Math.log(srcsize)/Math.log(1024));
      var size = srcsize/Math.pow(1024,index);
      size = size.toFixed(1);//保留的小数位数
      return size + unitArr[index];
    },
    async getPresignedUrlFun(filePath) {
      let _filePathMatch = filePath.match(/^((https?)(\:\/\/)[A-Za-z0-9\.]+[A-Za-z0-9](:[0-9]+)?\/)|^\/+/); // 截取host
      let _pathUrl = filePath.replace(/^((https?)(\:\/\/)[A-Za-z0-9\.]+[A-Za-z0-9](:[0-9]+)?\/)|^\/+/, ''); // 替换host
      let _hasImg = filePath.includes('img/')
        , _hostUrl = '';
      if(_filePathMatch) { // 保留host
        _hostUrl = _filePathMatch[0];
      }
      if(_hasImg) { // 有代理
        _pathUrl = _pathUrl.replace(/(img\/)*/,''); // 去掉代理，保留原始路径
        _hostUrl = _hostUrl + 'img/';
      }
      let _url = await presignedUrlFun(_hostUrl, _pathUrl);
      return _url;
    },
    // 检查 url 是否有前缀并截取
    checkUrlHasHostFun(url) {
      url = url || '';
      return url.replace(/^((https?)(\:\/\/)[A-Za-z0-9\.]+[A-Za-z0-9](:[0-9]+)?\/)|^\/+/,'').replace(/(img\/)*/,'')
      // if(url.includes('http://') || url.includes('https://') || url.includes('/M00/') || url.includes('/M00/')) {
      //   let _i = url.indexOf('M00/');
      //   return url.substr(_i);
      // } else {
      //   return url.replace('/img/', '');
      // }
    }
  }
});
/* eslint-disable no-new */
// 文件大小转化
Vue.filter('formatFileSize', function (value) {
  if(null==value||value==''){
    return "0B";
  }
  var unitArr = new Array("B","KB","MB","GB","TB","PB","EB","ZB","YB");
  var srcsize = parseFloat(value);
  var index = Math.floor(Math.log(srcsize)/Math.log(1024));
  var size = srcsize/Math.pow(1024,index);
  size = size.toFixed(1);//保留的小数位数
  return size + unitArr[index];
});
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js